import storage from "../helpers/storage";
import { resetAuthRefreshState } from "../services/auth-session";

const BUILD_STORAGE_KEY = "PTT_ADMIN_BUILD_ID";
const AUTH_MARKER = "auth-fix-v3";

/**
 * On new frontend build, clear stale tokens once (stops old-bundle refresh loops).
 */
export function bootstrapAuthStorage(): void {
  const buildId = process.env.REACT_APP_BUILD_ID || AUTH_MARKER;
  const previous = localStorage.getItem(BUILD_STORAGE_KEY);

  if (previous !== buildId) {
    storage.clearSession();
    resetAuthRefreshState();
    localStorage.setItem(BUILD_STORAGE_KEY, buildId);
    console.info("[PTT Admin] new build — cleared stale auth", { buildId });
  }
}
